import { Button, Icon } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { openListerCreateDialog } from '../../../../services/listerUploadVehicle';
import { useWindowSize } from 'usehooks-ts';
import { ManualUploadIcon } from '../../../../components/Icons/ManualUpload';
import { AutomaticUploadIcon } from '../../../../components/Icons/AutomaticUploadIcon';
import { openVinDialog } from 'services/listerUploadVehicle/v2';
import { useHideOnScroll } from 'hooks/useHideOnScroll';

const Wrapper = styled.div`
  display: flex;
  position: fixed;
  bottom: 86px;
  width: 100%;
  left: 0px;
  padding: 7px 28px 6px;
  background: rgba(211, 231, 247, 1);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

  &.hidden {
    transform: translateY(calc(100% + 86px));
    opacity: 0;
  }

  &.visible {
    transform: translateY(0);
    opacity: 1;
  }
`;

const StyledButton = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.41px;
  padding-top: 9px;
  padding-bottom: 11px;
  width: 100%;
`;

const popupAnimation = keyframes`
  0% {
    visibility: hidden;
    transform: translateY(100%);
    opacity: 1;
  }

  100% {
    visibility: visible;
    transform: translateY(0);
    opacity: 1;
  }
`;

const Popup = styled.div`
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: #fff;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 86px;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding: 20px 16px 28px;
  z-index: 9992;

  &.popup-hidden {
    visibility: hidden;
    opacity: 1;
    transform: translateY(100%);
  }

  &.popup-visible {
    visibility: visible;
    animation: ${popupAnimation} 0.5s ease-out forwards;
  }
`;

const PopupTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 22px;
  font-weight: 500;
  line-height: 25.78px;
  color: #000;
`;

const PopupButtons = styled.div`
  display: flex;
  gap: 16px;
`;

const Action = styled.div`
  flex: 1 1 100%;
  background: rgba(34, 90, 145, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 40px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  color: #fff;
`;

const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9991;
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;

  &.backdrop-hidden {
    visibility: hidden;
  }

  &.backdrop-visible {
    visibility: visible;
  }
`;

const IconWrapper = styled.div`
  display: flex;
`;

export const StartInspectionButton = () => {
  const { width = 0 } = useWindowSize();

  if (width > 1024) {
    return null;
  }

  return <ListingButton />;
};

const ListingButton = () => {
  const dispatch = useDispatch();

  const startInspection = () => {
    dispatch(openVinDialog({ vehicleId: null, type: 'upload' }));
  };

  useHideOnScroll('listing-btn');

  return (
    <Wrapper id="listing-btn">
      <StyledButton variant="contained" color="primary" type="button" onClick={startInspection}>
        Start Listing
      </StyledButton>
    </Wrapper>
  );
};

type PopupProps = {
  popupOpened: boolean;
  closePopup: () => void;
};

const ListingPopup = ({ popupOpened, closePopup }: PopupProps) => {
  const dispatch = useDispatch();
  const startInspection = () => {
    dispatch(openListerCreateDialog());
    closePopup();
  };

  return (
    <>
      <Backdrop className={popupOpened ? 'backdrop-visible' : 'backdrop-hidden'} />
      <Popup className={popupOpened ? 'popup-visible' : 'popup-hidden'}>
        <PopupTitle>
          <span>Upload</span>
          <Icon onClick={closePopup} style={{ color: '#000' }}>
            close
          </Icon>
        </PopupTitle>
        <PopupButtons>
          <Action onClick={startInspection}>
            <IconWrapper>
              <ManualUploadIcon />
            </IconWrapper>
            <span>Manual Upload</span>
          </Action>
          <Action onClick={startInspection}>
            <IconWrapper>
              <AutomaticUploadIcon />
            </IconWrapper>
            <span>Upload Vehicle</span>
          </Action>
        </PopupButtons>
      </Popup>
    </>
  );
};
